import { useState } from "react";
import { Button } from "react-admin";
import { DeleteOutlineOutlined } from '@mui/icons-material';
import ConfirmDeleteUserModal from "./ConfirmDeleteUserModal";

const DeleteUserButton = ({ userId, email }) => {
    const [modalOpen, setModalOpen] = useState(false);

    return (
        <>
            <Button
                type="button"
                onClick={() => setModalOpen(true)}
                color="error"
                variant="outlined"
                label="Excluir conta do usuário"
            >
                <DeleteOutlineOutlined />
            </Button>
            {modalOpen && (
                <ConfirmDeleteUserModal 
                    open={modalOpen}
                    onClose={() => setModalOpen(false)}
                    userId={userId}
                    email={email}
                />
            )}
        </>
    );
};

export default DeleteUserButton;